import { Testimonial } from '../models/testimonial.model';

export const TESTIMONIALS: Testimonial[] = [
    {
      name: 'Ahmed Chaabani',
      role: 'Student - Grade 11 Sciences',
      content: 'Tenjah School has completely changed how I learn. The interactive lessons and instant feedback help me understand complex topics easily. My grades have improved significantly since joining!',
      rating: 5,
      initials: 'AC',
      subject: 'Mathematics & Physics'
    },
    {
      name: 'Yasmine Ben Ali',
      role: 'Student - Grade 9 Literature',
      content: 'I love how I can access all my courses from anywhere. The mobile app lets me study during breaks and the teacher communication feature helps me get quick answers to my questions.',
      rating: 5,
      initials: 'YB',
      subject: 'Arabic Literature'
    },
    {
      name: 'Fatma Sellami',
      role: 'Parent - Mother of 2 Students',
      content: 'As a parent, being able to track my children\'s progress in real-time has been incredible. I can see their assignments, grades, and communicate directly with teachers. It keeps me involved in their education.',
      rating: 5,
      initials: 'FS',
      subject: 'Parent Feedback'
    },
    {
      name: 'Mohamed Trabelsi',
      role: 'Student - Grade 12 Economics',
      content: 'The personalized learning paths have been game-changing for my BAC preparation. The AI-powered recommendations help me focus on areas where I need improvement. I feel confident about my exams now!',
      rating: 5,
      initials: 'MT',
      subject: 'Economics & Management'
    },
    {
      name: 'Leila Mansouri',
      role: 'Parent - Father of Grade 8 Student',
      content: 'My daughter went from struggling with math to becoming one of the top students in her class. The adaptive learning system and gamification features kept her engaged and motivated.',
      rating: 5,
      initials: 'LM',
      subject: 'Mathematics'
    },
    {
      name: 'Karim Ferjani',
      role: 'Student - Grade 10 Sciences',
      content: 'The virtual lab experiments are amazing! I can practice chemistry and physics experiments safely at home. The 3D simulations make complex concepts so much easier to understand.',
      rating: 4,
      initials: 'KF',
      subject: 'Chemistry & Physics'
    },
    {
      name: 'Nadia Bouazizi',
      role: 'Parent - Mother of Grade 7 Student',
      content: 'The multilingual support has been incredible for our family. My son can learn in both Arabic and French, which has strengthened his language skills tremendously.',
      rating: 5,
      initials: 'NB',
      subject: 'Language Learning'
    },
    {
      name: 'Sami Khedri',
      role: 'Student - Grade 11 Technology',
      content: 'The coding workshops and robotics simulations have sparked my passion for technology. I\'m now planning to pursue computer science in university thanks to Tenjah School!',
      rating: 5,
      initials: 'SK',
      subject: 'Technology & Programming'
    },
    {
      name: 'Amina Jaziri',
      role: 'Parent - Mother of Grade 6 Student',
      content: 'The transition from traditional learning to digital was seamless. My daughter adapted quickly, and her creativity has flourished with the interactive art and music modules.',
      rating: 4,
      initials: 'AJ',
      subject: 'Arts & Creativity'
    },
    {
      name: 'Omar Zouari',
      role: 'Student - Grade 9 Sports Section',
      content: 'Balancing sports and academics was always challenging. Tenjah School\'s flexible scheduling and mobile learning have allowed me to excel in both areas without compromise.',
      rating: 5,
      initials: 'OZ',
      subject: 'Sports & Academics'
    }
];
